import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSupabase, supabasePublic } from "./supabaseClient";
import { recordAuthEvent } from "../services/rlsAudit";

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const signOutUser = async () => {
      try {
        // First, get the current session to know the user ID
        const {
          data: { session },
        } = await supabasePublic().auth.getSession();

        if (session?.user) {
          // Try to mark as offline before signing out
          // This uses a direct channel approach for immediate presence update
          const userId = session.user.id;

          // Create a temporary channel to update presence
          const tempChannel = supabasePublic().channel(
            `signout-presence-${userId}`,
            {
              config: {
                presence: { key: userId },
              },
            },
          );

          await tempChannel.track({
            user_id: userId,
            status: "offline",
            signed_out_at: new Date().toISOString(),
          });

          // Untrack immediately
          await tempChannel.untrack();
          await tempChannel.unsubscribe();

          console.log("User marked as offline");
        }
      } catch (presenceError) {
        console.log("Presence update failed (non-critical):", presenceError);
      }

      // Now sign out from Supabase Auth
      const supabase = await getSupabase();
      await recordAuthEvent("logout");
      const { error } = await supabase.auth.signOut();

      if (error) {
        console.error("Error signing out:", error.message);
      } else {
        console.log("User signed out successfully");

        // Clear any auth-related sessionStorage
        sessionStorage.clear();

        navigate("/");
      }
    };

    signOutUser();
  }, [navigate]);

  return (
    <div>
      <p>Signing out...</p>
    </div>
  );
};

export default SignOut;
